import React from 'react'
import { ImageMedia, MotionContent, Page } from '../../components/imports'

const Cookies = () => {

  const privacyDeclaration = <>
    LAWWD (« LAWWD ») met à disposition ce site web, <span id="buttonUnderline2" className='relative border-b border1'>www.lawwd.co</span>, ainsi qu’une newsletter intitulée « Designed by LAWWD », envoyée par email aux abonnés sur une base mensuelle (ensemble désignés comme le « Site ») à des fins informatives.
    <br /><br />
    En accédant au Site, vous acceptez ces Conditions d'utilisation et cette Politique de Confidentialité, qui peuvent être modifiées de temps à autre, sans restriction ni réserve. Si vous n’acceptez pas ces conditions, veuillez ne pas poursuivre l'utilisation du Site.
    <br /><br />
    <b>**Droits d'Auteur et Protection des Contenus**</b><br />
    Tous les contenus du Site, y compris les images, textes, logiciels, documents, fichiers multimédias et autres matériaux, sont protégés par des lois sur le droit d’auteur. LAWWD conserve tous les droits de propriété intellectuelle sur ces contenus. Toute reproduction, modification ou exploitation sans autorisation expresse est interdite.
    <br /><br />
    <b>**Utilisation Commerciale Restreinte**</b><br />
    Toute publication ou exploitation non autorisée des contenus de LAWWD à des fins commerciales est strictement interdite. Toute demande d'utilisation de ces contenus doit être adressée à <a href="mailto:contact@lawwd.co" id="buttonUnderline" className='relative'> <i className='ri-mail-fill mr-1' />contact@lawwd.co</a>.
    <br /><br />
    <b>**Réserve de Droits**</b><br />
    Tous les droits qui ne sont pas expressément accordés par LAWWD restent réservés. Aucune disposition des présentes conditions ne confère un droit ou une licence d’utilisation sur des contenus appartenant à des tiers.
    <br /><br />
    <b>**Marques**</b><br />
    « LAWWD » est une marque déposée de LAWWD. Toute utilisation de cette marque sans autorisation écrite préalable est interdite. Les marques présentes sur le Site appartenant à des tiers restent la propriété de leurs détenteurs respectifs.
    <br /><br />
    <b>**Protection des Données Personnelles**</b><br />
    LAWWD s’engage à protéger la vie privée des visiteurs du Site en conformité avec les lois en vigueur au Sénégal.
    <br /><br />
    Nous collectons certaines informations anonymisées sur votre activité sur le Site, y compris votre adresse IP, le type d’appareil et de navigateur que vous utilisez. Si vous vous abonnez à notre newsletter, nous collectons et conservons votre adresse email.
    <br /><br />
    LAWWD utilise ces informations pour :
    - Analyser l’utilisation du Site afin d’améliorer l’expérience utilisateur.
    - Vous envoyer des communications via la newsletter.
    <br /><br />
    Les informations collectées de manière anonymisée peuvent être conservées indéfiniment à des fins de sécurité et d’amélioration du Site. Votre adresse email sera conservée aussi longtemps que vous resterez abonné à la newsletter. Vous avez toujours la possibilité de vous désinscrire.
    <br /><br />
    Nous pouvons partager certaines informations avec des services tiers de confiance afin d’améliorer ou protéger le Site et la newsletter. Ces tiers sont tenus d’utiliser ces informations uniquement aux fins autorisées par LAWWD et de respecter des normes de protection des données équivalentes aux nôtres.
    <br /><br />
    <b>**Liens vers des Sites Tiers**</b><br />
    LAWWD peut contenir des liens vers des sites tiers dont les pratiques en matière de confidentialité peuvent différer. Lorsque vous accédez à un site externe, sa politique de confidentialité s'applique.
    <br /><br />
    <b>**Exclusion de Responsabilité**</b><br />
    LE SITE EST FOURNI « TEL QUEL ». SON UTILISATION SE FAIT À VOS PROPRES RISQUES. LAWWD DÉCLINE TOUTE RESPONSABILITÉ QUANT À DES ÉVENTUELS DYSFONCTIONNEMENTS, INTERRUPTIONS OU ERREURS SUR LE SITE. LAWWD N’ASSUME AUCUNE RESPONSABILITÉ EN CAS DE DOMMAGES MATÉRIELS OU IMMATERIELS DÉCOULANT DE L’UTILISATION DU SITE.
    <br /><br />
    <b>**Limitation de Responsabilité**</b><br />
    LAWWD, SES DIRIGEANTS, EMPLOYÉS ET PARTENAIRES NE POURRONT ÊTRE TENUS RESPONSABLES DE TOUT DOMMAGE DIRECT OU INDIRECT DÉCOULANT DE L’UTILISATION DU SITE OU DE SON CONTENU.
    <br /><br />
    <b>**Indemnisation**</b><br />
    En utilisant le Site, vous acceptez d'indemniser et de garantir LAWWD contre toute réclamation, frais ou dommages résultant de votre utilisation non conforme du Site.
    <br /><br />
    <b>**Droit Applicable et Compétence**</b><br />
    Ces conditions sont régies par le droit sénégalais. Tout litige relatif à ces conditions sera soumis à la compétence exclusive des tribunaux de Dakar.
    <br /><br />
    <b>**Dispositions Générales**</b><br />
    Si une disposition des présentes conditions est jugée inapplicable, elle sera supprimée sans affecter les autres dispositions. L’absence d'application d'une disposition par LAWWD ne constitue pas une renonciation à ce droit.
    <br /><br />
    Ces Conditions d'utilisation ont été mises à jour le 1 Janvier 2025.

  </>


  return (

    <Page offset>
      <div className='resp'>
        <div className='flexResp h-full relative pb-44'>
          <div className='flex flex-col sticky top-[10vh] lg:h-screen== lg:h-full w-full pt-[10vh]  ======signal'>
            <h1 className='lg:landscape:max-w-[15ch] text-right block leading-none lg:landscape:sticky lg:top-0'>
              {/* 🕵🏾‍♂️  */}Politique de Confidentialité
              <span className='block text-sm muted dim mt-7 pb-1'>
                1 Janvier 2025
              </span>
            </h1>
          </div>

          <div className='h-[300vh]= min-h-fit pl-[5vw] pt-[35ch]'>
            <h5 className='text-justify'>{privacyDeclaration}</h5>
          </div>
        </div>
      </div>
      <div className=''>
        <MotionContent height={"h-[60vh]"}>
          <ImageMedia src={require('../../assets/images/LAWWD_BusinessCard (4).jpg')} />
        </MotionContent>
      </div>
      <div className='h-[5vh]' />
    </Page>
  )
}

export default Cookies